/* GPROPERTY-SPATIAL-AREA-SKETCH-01
 * Public map sketch mathematics only. No survey accuracy, PM01, BA01,
 * certified boundary, server call, customer record, or persisted location.
 * Equirectangular local tangent approximation is bounded to 5km spans.
 */
(function (root) {
  'use strict';

  var R = 6371008.8;
  var RAD = Math.PI / 180;
  var MAX_POINTS = 64;
  var MAX_SPAN_METRES = 5000;

  function invalid(code) {
    var error = new Error(code);
    error.code = code;
    throw error;
  }
  function finite(n) {
    return typeof n === 'number' && Number.isFinite(n);
  }
  function same(a, b) {
    return Math.hypot(a[0] - b[0], a[1] - b[1]) < 0.5;
  }
  function cross(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function onSegment(a, b, p) {
    return Math.min(a[0], b[0]) - 1e-6 <= p[0] &&
      p[0] <= Math.max(a[0], b[0]) + 1e-6 &&
      Math.min(a[1], b[1]) - 1e-6 <= p[1] &&
      p[1] <= Math.max(a[1], b[1]) + 1e-6;
  }
  function intersects(a, b, c, d) {
    var x1 = cross(a,b,c), x2 = cross(a,b,d), x3 = cross(c,d,a), x4 = cross(c,d,b);
    if ((x1 > 1e-6 && x2 < -1e-6 || x1 < -1e-6 && x2 > 1e-6) &&
        (x3 > 1e-6 && x4 < -1e-6 || x3 < -1e-6 && x4 > 1e-6)) return true;
    return Math.abs(x1) <= 1e-6 && onSegment(a,b,c) ||
      Math.abs(x2) <= 1e-6 && onSegment(a,b,d) ||
      Math.abs(x3) <= 1e-6 && onSegment(c,d,a) ||
      Math.abs(x4) <= 1e-6 && onSegment(c,d,b);
  }

  function analyze(vertices) {
    if (!Array.isArray(vertices) || vertices.length < 3) invalid('NOT_ENOUGH_POINTS');
    if (vertices.length > MAX_POINTS) invalid('TOO_MANY_POINTS');
    var lat0 = 0, lng0 = null;
    vertices.forEach(function(p) {
      if (!p || !finite(p.lat) || !finite(p.lng) ||
          Math.abs(p.lat) > 85 || Math.abs(p.lng) > 180) invalid('INVALID_VERTEX');
      lat0 += p.lat;
      if (lng0 === null) lng0 = p.lng;
      if (Math.abs(p.lng - lng0) > 180) invalid('DATELINE_UNSUPPORTED');
    });
    lat0 /= vertices.length;
    var p0 = vertices[0];
    var cosine = Math.cos(lat0 * RAD);
    var xy = vertices.map(function(p) {
      return [(p.lng - p0.lng) * RAD * R * cosine, (p.lat - p0.lat) * RAD * R];
    });
    var minX=Infinity,maxX=-Infinity,minY=Infinity,maxY=-Infinity;
    xy.forEach(function(p,i) {
      minX = Math.min(minX,p[0]); maxX=Math.max(maxX,p[0]);
      minY = Math.min(minY,p[1]); maxY=Math.max(maxY,p[1]);
      if (same(p,xy[(i+1)%xy.length])) invalid('DUPLICATE_VERTEX');
    });
    if (Math.hypot(maxX-minX,maxY-minY) > MAX_SPAN_METRES) invalid('TOO_LARGE_FOR_SKETCH');
    for(var i=0;i<xy.length;i++) {
      var a=xy[i],b=xy[(i+1)%xy.length];
      for(var j=i+1;j<xy.length;j++) {
        if (j===i+1 || i===0&&j===xy.length-1) continue;
        if (intersects(a,b,xy[j],xy[(j+1)%xy.length])) invalid('BOUNDARY_SELF_INTERSECTS');
      }
    }
    var twiceArea=0,perimeter=0;
    for (var k=0;k<xy.length;k++) {
      var from=xy[k],to=xy[(k+1)%xy.length];
      twiceArea += from[0]*to[1]-to[0]*from[1];
      perimeter += Math.hypot(to[0]-from[0],to[1]-from[1]);
    }
    var area = Math.abs(twiceArea)/2;
    if (!finite(area) || area<0.5 || !finite(perimeter)) invalid('DEGENERATE_AREA');
    return {
      algorithm: 'map_sketch_local_tangent_v1',
      input_crs: 'EPSG:4326',
      area_m2: area,
      perimeter_m: perimeter,
      point_count:xy.length,
      span_limit_m: MAX_SPAN_METRES,
      approximation_only:true,
      measured_geometry_verified:false,
      statutory_approved:false,
      repo_b_pm01_executed:false
    };
  }

  root.GPropertySpatialAreaMath = Object.freeze({analyze:analyze, MAX_POINTS:MAX_POINTS});
})(typeof window === 'undefined' ? globalThis : window);
